module.exports = __webpack_public_path__ + "media/images/landing_page/2023/header_img-0b5e8030b70c269ad38ab6b8e011d54c.jpg";